import {
    Grid,
    useTheme,
    useMediaQuery
} from '@mui/material'

import Announcements from './Announcements';
import HideForms from '../../../components/SendPulseForms/hide';

import "dayjs/locale/uk";


const AnnouncementsLayout = () => {
    const theme = useTheme();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <HideForms />
            <Grid container spacing={0} columns={{ xs: 4, md: 5, lg: 12 }} sx={{ mt: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "43px", lg: "120px" } }}>
                {(isXl || isLg) && <Announcements rowsPerPage={10} />}
                {isMd && <Announcements rowsPerPage={5} />}
                {isXs && <Announcements rowsPerPage={4} />}
            </Grid>
        </>
    )
}

export default AnnouncementsLayout